import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { filterArrId, Optios } from "../utils/utils"
import { branchService } from "../views/masterDataList/dataBranch/dataBranchService"
import { IBranchDetail } from "../views/masterDataList/dataBranch/dataBranchTypes"

//物料类型
import { materielTypeService } from "../views/masterDataService/materielType/materielTypeService"
import { IMaterielTypeDetail } from "../views/masterDataService/materielType/materielTypeTypes"
//字典数据
import { dictService } from "../views/masterDataService/dict/dictService"
import { IDictDetail } from "../views/masterDataService/dict/dictTypes"

import { catalogService } from "../views/masterDataList/dataCatalog/dataCatalogService"
import { ICatalogDetail } from "../views/masterDataList/dataCatalog/dataCatalogTypes"
//客户数据
import { customerService } from "../views/masterDataService/customer/customerService"
import { ICustomerDetail } from "../views/masterDataService/customer/customerTypes"
//组织机构
import { organService } from "../views/masterDataService/organization/organizationService"
import { IOrganDetail } from "../views/masterDataService/organization/organizationTypes"
import { entityService } from "../views/masterDataService/entity/entityService";
//用户数据
import { userService } from "../views/masterDataService/user/userService"
import { IUserDetail } from "../views/masterDataService/user/userTypes"
//门店管理
import { shopService, ISCMShopDetail } from "../views/masterDataService/shop/shopService"
import { applyService } from "../views/masterDataService/apply/applyService";
import { IApplyDetail } from "../views/masterDataService/apply/applyTypes";


function listChangeTree(list: IDictDetail[]) {
    // debugger;
    let menuObj: any = {}
    list.forEach(item => {
        item.children = []
        item.title = item.name
        item.value = item.code
        item.key = item.value
        menuObj[item.code as string] = item
    })
    // return menuObj
    return list.filter(item => {
        if (item.pcode !== null && item.pcode !== "") {
            menuObj[item.pcode as string]?.children.push({ ...item, key: item.value })
            return false
        }
        return true
    })
}
function useModel() {
    const initCatalog: Optios[] = [];
    const initBranch: Optios[] = [];
    const initSourceApp: Optios[] = [];
    // const initSourceApp: Optios[] = [{ key: "fms", label: "财务系统", value: "fms" }, { key: "vrm", label: "云修系统", value: "vrm" }];
    const initOrgan: IOrganDetail[] = []
    const initMaterielType: IMaterielTypeDetail[] = []
    const initDict: IDictDetail[] = []
    const initCustomer: Optios[] = []
    const [mdmCatalog, setCatalog, resetCatalog] = useStorageState<Optios[]>('catalog', initCatalog);
    const [mdmBranch, setBranch, resetBranch] = useStorageState<Optios[]>('branch', initBranch);
    const [mdmSourceApp, setMdmSourceApp, resetMdmSourceApp] = useStorageState<Optios[]>('sourceApp', initSourceApp);
    const [mdmOrgan, setMdmOrgan, resetMdmOrgan] = useStorageState<IOrganDetail[]>('organ', initOrgan);
    const [materielType, setMaterielType, resetMaterielType] = useStorageState<IMaterielTypeDetail[]>('materielType', initMaterielType);//物料类型
    const [dict, setDict, resetDict] = useStorageState<IDictDetail[]>('dict', initDict);//字典类型
    const [customer, setCustomer, resetCustomer] = useStorageState<Optios[]>('customer', initCustomer);//客户类型
    const [userAll, setUserAll, resetUserAll] = useStorageState<Optios[]>('userAll', initCustomer);//用户
    const [shop, setShop, resetShop] = useStorageState<Optios[]>('shopAll', initCustomer);//门店


    const [entity, setEntity, resetEntity] = useStorageState<Optios[]>('entity', []);//经营实体
    const searchParams = {
        page: {
            pageSize: 10000,
            pageNum: 1
        }
    }

    const initApplyData = async () => {
        const { retData } = await applyService.page(searchParams)
        const { records, ...pg } = retData
        const newArr = filterArrId<IApplyDetail>(records, "code")
        setMdmSourceApp(newArr)
    }

    const initCatalogData = async () => {
        const { retData } = await catalogService.page(searchParams);
        const { records, ...pg } = retData;
        const newArr = filterArrId<ICatalogDetail>(records, "code", "code")
        setCatalog(newArr)
    }
    const initBranchData = async () => {
        const { retData } = await branchService.page(searchParams)
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records, "code", "code")
        setBranch(newArr)
    }
    const initDictDatas = async () => {
        const { retData } = await dictService.page(searchParams)
        const { records, ...pg } = retData
        // console.log(records)
        // console.log(listChangeTree(records))
        setDict(listChangeTree(records.filter(item => item.enable)) as never[])
    }
    const initCustomerData = async () => {
        const { retData } = await customerService.page(searchParams)
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records)
        setCustomer(newArr)
    }
    const initMdmOrganTree = async () => {//组织机构树
        const { retData } = await organService.page(searchParams)
        const { records, ...pg } = retData
        setMdmOrgan(listChangeTree(records) as never[])
    }
    const initMdmEntityData = async () => {//经营实体
        const { retData } = await entityService.page(searchParams);
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records)
        setEntity(newArr)
    }
    const initMdmUser = async () => {//用户列表
        const { retData } = await userService.page(searchParams)
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records)
        setUserAll(newArr)
    }
    const initMdmShop = async () => {//门店管理
        const { retData } = await shopService.page(searchParams)
        const { records, ...pg } = retData
        const newArr = filterArrId<IBranchDetail>(records)
        setShop(newArr)
    }
    return {
        mdmCatalog,
        mdmBranch,
        mdmSourceApp,
        mdmOrgan,
        dict,
        customer,
        entity,
        userAll,
        shop,
        setShop,
        resetShop,
        setUserAll,
        resetUserAll,
        setMdmSourceApp,
        setCatalog,
        setDict,
        setCustomer,
        resetCatalog,
        initCatalogData,
        initBranchData,
        setBranch,
        resetBranch,
        resetMdmSourceApp,
        resetCustomer,
        setMdmOrgan,
        resetMaterielType,
        initMdmOrganTree,
        initCustomerData,
        initDictDatas,
        resetDict,
        resetMdmOrgan,
        initMdmEntityData,
        initMdmUser,
        initMdmShop,
        initApplyData
    }
}
export const useMdmModel = createModel(useModel)
export default useMdmModel;
